import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	education__courses: 'mw/education/courses',
	education__courses__id: 'mw/education/courses/:courseId',
	education__tasks__id: 'mw/education/tasks/:courseId',
	education__quiz__id: 'mw/education/quizzes/:courseId',
	education__stream: 'mw/education/courses/:courseId/stream',
	education__classwork: 'mw/education/courses/:courseId/classwork',
	education__materials: 'mw/education/courses/:courseId/materials',
	education__progress: 'mw/education/courses/:courseId/progress',
	education__reviews: 'mw/education/reviews',
	education__comments: 'mw/education/comments',
	education__task__comments: 'mw/education/tasks/:taskId/comments',
	education__search: 'mw/education/search',
	education__mentor__courses: 'mw/education/courses/mentor',
};

export const educationApi = createApi({
	reducerPath: 'mw/educationApi',

	endpoints: (builder) => ({
		educationCourses: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/education/courses?${qs.stringify(body)}`,
			}),
			providesTags: [tags.education__courses],
		}),
		educationMentorCourses: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/education/courses/mentor',
			}),
			providesTags: [tags.education__mentor__courses],
		}),
		educationCoursesById: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}`,
			}),
			providesTags: [tags.education__courses__id],
		}),
		educationCourseStream: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}/stream`,
			}),
			providesTags: [tags.education__stream],
		}),
		educationCoursePostCreate: builder.mutation({
			query: ({ courseId, body }) => ({
				method: 'POST',
				url: `/mw/education/courses/${courseId}/posts`,
				body,
			}),
			invalidatesTags: [tags.education__stream],
		}),
		educationCoursePostDelete: builder.mutation({
			query: ({ postId }) => ({
				method: 'DELETE',
				url: `/mw/education/posts/${postId}`,
			}),
			invalidatesTags: [tags.education__stream, tags.education__comments],
		}),
		educationCourseClasswork: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}/classwork`,
			}),
			providesTags: [tags.education__classwork],
		}),
		educationCourseMaterials: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}/materials`,
			}),
			providesTags: [tags.education__materials],
		}),
		educationCourseProgress: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}/progress`,
			}),
			providesTags: [tags.education__progress],
		}),
		educationCourseSearch: builder.query({
			query: ({ courseId, query }) => ({
				method: 'GET',
				url: `/mw/education/search?${qs.stringify({ courseId, query })}`,
			}),
			providesTags: [tags.education__search],
		}),
		educationPostComments: builder.query({
			query: ({ postId }) => ({
				method: 'GET',
				url: `/mw/education/posts/${postId}/comments`,
			}),
			providesTags: [tags.education__comments],
		}),
		educationPostCommentCreate: builder.mutation({
			query: ({ postId, body }) => ({
				method: 'POST',
				url: `/mw/education/posts/${postId}/comments`,
				body,
			}),
			invalidatesTags: [tags.education__comments, tags.education__stream],
		}),
		educationPostCommentDelete: builder.mutation({
			query: ({ postId, commentId }) => ({
				method: 'DELETE',
				url: `/mw/education/posts/${postId}/comments/${commentId}`,
			}),
			invalidatesTags: [tags.education__comments, tags.education__stream],
		}),
		educationTaskComments: builder.query({
			query: ({ taskId }) => ({
				method: 'GET',
				url: `/mw/education/tasks/${taskId}/comments`,
			}),
			providesTags: [tags.education__task__comments],
		}),
		educationTaskCommentCreate: builder.mutation({
			query: ({ taskId, body }) => ({
				method: 'POST',
				url: `/mw/education/tasks/${taskId}/comments`,
				body,
			}),
			invalidatesTags: [tags.education__task__comments],
		}),
		educationTaskCommentDelete: builder.mutation({
			query: ({ taskId, commentId }) => ({
				method: 'DELETE',
				url: `/mw/education/tasks/${taskId}/comments/${commentId}`,
			}),
			invalidatesTags: [tags.education__task__comments],
		}),
		educationMaterialReviews: builder.query({
			query: ({ materialId }) => ({
				method: 'GET',
				url: `/mw/education/materials/${materialId}/reviews`,
			}),
			providesTags: [tags.education__reviews],
		}),
		educationMaterialReviewCreate: builder.mutation({
			query: ({ materialId, body }) => ({
				method: 'POST',
				url: `/mw/education/materials/${materialId}/reviews`,
				body,
			}),
			invalidatesTags: [tags.education__reviews, tags.education__materials],
		}),
		educationCourseReviews: builder.query({
			query: ({ courseId }) => ({
				method: 'GET',
				url: `/mw/education/courses/${courseId}/reviews`,
			}),
			providesTags: [tags.education__reviews],
		}),
		educationCourseReviewCreate: builder.mutation({
			query: ({ courseId, body }) => ({
				method: 'POST',
				url: `/mw/education/courses/${courseId}/reviews`,
				body,
			}),
			invalidatesTags: [tags.education__reviews],
		}),
		educationTasksById: builder.query({
			query: ({ taskId }) => ({
				method: 'GET',
				url: `/mw/education/tasks/${taskId}`,
			}),
			providesTags: [tags.education__tasks__id],
		}),
		educationQuizById: builder.query({
			query: ({ quizId }) => ({
				method: 'GET',
				url: `/mw/education/quizzes/${quizId}`,
			}),
			providesTags: [tags.education__quiz__id],
		}),
		educationQuizAnswersById: builder.query({
			query: ({ quizId }) => ({
				method: 'GET',
				url: `/mw/education/quizzes/${quizId}/answers`,
			}),
			providesTags: [tags.education__quiz__id],
		}),
		educationQuizSubmit: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/education/quizzes/answers-submitted',
				body,
			}),
			invalidatesTags: [tags.education__quiz__id],
		}),
	educationTaskSubmit: builder.mutation({
		query: ({ taskId, body }) => ({
			method: 'POST',
			url: `/mw/education/tasks/${taskId}/submitted`,
			body,
			formData: true,
		}),
		invalidatesTags: [tags.education__tasks__id],
	}),
	educationTaskResourceDelete: builder.mutation({
		query: ({ taskId, resourceId }) => ({
			method: 'DELETE',
			url: `/mw/education/tasks/${taskId}/resources/${resourceId}`,
		}),
		invalidatesTags: [tags.education__tasks__id],
	}),
	}),
});

export const {
	educationCourses,
	educationMentorCourses,
	educationCoursesById,
	educationCourseStream,
	educationCoursePostCreate,
	educationCoursePostDelete,
	educationCourseClasswork,
	educationCourseMaterials,
	educationCourseProgress,
	educationCourseSearch,
	educationPostComments,
	educationPostCommentCreate,
	educationPostCommentDelete,
	educationTaskComments,
	educationTaskCommentCreate,
	educationTaskCommentDelete,
	educationMaterialReviews,
	educationMaterialReviewCreate,
	educationCourseReviews,
	educationCourseReviewCreate,
	educationTasksById,
	educationQuizById,
	educationQuizAnswersById,
	educationQuizSubmit,
	educationTaskSubmit,
	educationTaskResourceDelete,
} = educationApi.endpoints;

export default educationApi;
